export let availableSprites = [
    "<none>",
    "./sprites/enemies/skeleton_mage/skelemage.json",
    "./sprites/heroes/export_player_dwarf/player.json",
    "./sprites/player-skins/player.json",
]
